import React, { useState, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { postCampaignData, putCampaignData } from "api/CampaignApi";
import moment from "moment";
import './style.scss';
export default function CampaignABTestScheduleModal() {
  const campaignData = useSelector(state => state.campaignSetter);
  const history = useHistory();
  const [scheduleATime, setScheduleATime] = useState(null);
  const [scheduleBTime, setScheduleBTime] = useState(null);
  const [scheduleADate, setScheduleADate] = useState(null);
  const [scheduleBDate, setScheduleBDate] = useState(null);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const submitABTestSchedule = (e) => {
    forceUpdate();
    var data = {
      name: campaignData.campaignName,
      description: campaignData.campaignDescription,
      subject: campaignData.campaignSubject,
      templateId: campaignData.campaignTemplateId,
      audienceId: campaignData.campaignAudienceId,
      type: campaignData.campaignType,
      isDraft: false,
      cc : campaignData.cc,
      bcc : campaignData.bcc,
      campaignSchedule: {
        type: "once",
        firstRunDate: scheduleADate,
        runTime: scheduleATime,
      },
      ABTestData: {
        variationType: campaignData.campaingABTestData.campaignABTestVariation,
        samplePercentage: campaignData.campaingABTestData.campaignABTestPercentage,
        waitTime: campaignData.campaingABTestData.campaignABTestWaitTime,
        subject: campaignData.campaingABTestData.campaignABTestSubject,
        ABTestCampaignId: campaignData.campaingABTestData.campaignABTestId,
        decidingParameter: campaignData.campaingABTestData.campaignABTestDecidingParameter,
        campaignSchedule: {
          type: "once",
          firstRunDate: campaignData.campaingABTestData.campaignABTestVariation !== "Schedule" ? scheduleADate : scheduleBDate,
          runTime: campaignData.campaingABTestData.campaignABTestVariation !== "Schedule" ? scheduleATime : scheduleBTime,
        },
      },

    };

    console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCBBBBBBB",campaignData.cc , campaignData.bcc)

    putCampaignData(data, campaignData.campaignId)
      .then((data) => {
        toast.success(
          "Your campaign has been successfully scheduled for sending."
        );
        history.push(`/admin/campaign/all`);
      })
      .catch((e) => { });
  }

  // ANCHOR Date Handler
  const datePickupHandler = (e) => {
    e.preventDefault();
    //Update state
    if (e.target.id == 'abTestScheduleDateA') {
      setScheduleADate(e.target.value);
    } else if (e.target.id == 'abTestScheduleDateB') {
      setScheduleBDate(e.target.value);
    }
  };

  // ANCHOR Time Handler
  const timePickupHandler = (e) => {

    var ts = e.target.value;
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " am" : " pm";
    ts = h + ts.substr(2, 3) + ampm;


    if (e.target.id == 'abTestScheduleTimeA') {
      setScheduleATime(ts);
    } else if (e.target.id == 'abTestScheduleTimeB') {
      setScheduleBTime(ts);
    }
  };

  const submitSchedule = (e) => {
    e.preventDefault();
    var data = {
      name: campaignData.campaignName,
      description: campaignData.campaignDescription,
      subject: campaignData.campaignSubject,
      templateId: campaignData.campaignTemplateId,
      audienceId: campaignData.campaignAudienceId,
      type: campaignData.campaignType,
      isDraft: false,
      cc : campaignData.cc,
      bcc : campaignData.bcc,
      campaignSchedule: {
        type: "now",
      },
      ABTestData: {
        variationType: campaignData.campaingABTestData.campaignABTestVariation,
        samplePercentage: campaignData.campaingABTestData.campaignABTestPercentage,
        waitTime: campaignData.campaingABTestData.campaignABTestWaitTime,
        subject: campaignData.campaingABTestData.campaignABTestSubject,
        ABTestCampaignId: campaignData.campaingABTestData.campaignABTestId,
        decidingParameter: campaignData.campaingABTestData.campaignABTestDecidingParameter,
        campaignSchedule: {
          type: "now",
        },
      },
    };
    console.log("CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCBBBBBBB",campaignData.cc , campaignData.bcc)
    putCampaignData(data, campaignData.campaignId)
      .then((data) => {
        toast.success(
          "Your campaign has been successfully scheduled for sending."
        );
        history.push(`/admin/campaign/all`);
      })
      .catch((e) => { });

  }


  return (
    <>
      <div class='modal fade kwDesignModal kwABTestModal' id='scheduleABTest'>
        <div class='modal-dialog kw_md'>
          <div class='modal-content'>
            <div class='modal-header'>
              <button type='button' class='close' data-dismiss='modal'>
                <span class='icon-Group-240'></span>
              </button>
            </div>

            <div class='modal-body'>
              <form className='w-100 h-100' onSubmit={submitABTestSchedule}>
                {!(campaignData.campaingABTestData.campaignABTestVariation === 'Schedule') && <div className="schedule d-flex flex-wrap align-items-center justify-content-between">
                  <h3 className="font2">Run your campaign now</h3>
                  <input
                    type="submit"
                    className="lg_btn primary"
                    id="Run_Now"
                    value="Run Now"
                    data-dismiss="modal"
                    onClick={(e) => submitSchedule(e)}
                  />
                </div>}
                <div className='d-flex w-100 h-75'>
                  {
                    campaignData.campaingABTestData.campaignABTestVariation === 'Schedule' ? <>
                      {/* Schedule A */}
                      <div className='scheduleA w-50 h-100'>
                        <h3 className="scheduleAHeading">Schedule A</h3>
                        <div className="kwFields mt-5">
                          <div className="inline-fields-row justify-content-center">
                            <div className="datePickerOuter">
                              <input
                                id="abTestScheduleDateA"
                                onChange={datePickupHandler}
                                type="date"
                                min={moment().format("YYYY-MM-DD")}
                                className="kwDesign md datePicker w143"
                              />
                            </div>
                            &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                            <input
                              id="abTestScheduleTimeA"
                              className="kwDesign md timepicker w143 mt-5"
                              type="time"
                              onChange={timePickupHandler}
                            />
                            <span className="input_label ml-2 mt-5">EST</span>
                          </div>
                        </div>
                      </div>
                      {/* Schedule B */}
                      <div className='scheduleB w-50 h-100'>
                        <h3 className="scheduleBHeading">Schedule B</h3>
                        <div className="kwFields mt-5">
                          <div className="inline-fields-row justify-content-center">
                            <div className="datePickerOuter">
                              <input
                                id="abTestScheduleDateB"
                                onChange={datePickupHandler}
                                type="date"
                                min={moment().format("YYYY-MM-DD")}
                                className="kwDesign md datePicker w143"
                              />
                            </div>
                            &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                            <input
                              id="abTestScheduleTimeB"
                              className="kwDesign md timepicker w143 mt-5"
                              type="time"
                              onChange={timePickupHandler}
                            />
                            <span className="input_label ml-2 mt-5">EST</span>
                          </div>
                        </div>
                      </div>
                    </> : <div className='scheduleA w-50 h-100'>
                      <h3 className="scheduleAHeading">Schedule</h3>
                      <div className="kwFields mt-5">
                        <div className="inline-fields-row justify-content-center">
                          <div className="datePickerOuter">
                            <input
                              id="abTestScheduleDateA"
                              onChange={datePickupHandler}
                              type="date"
                              min={moment().format("YYYY-MM-DD")}
                              className="kwDesign md datePicker w143"
                            />
                          </div>
                          &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                          <input
                            id="abTestScheduleTimeA"
                            className="kwDesign md timepicker w143 mt-5"
                            type="time"
                            onChange={timePickupHandler}
                          />
                          <span className="input_label ml-2 mt-5">EST</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                {/* Schedule Bottom Section */}
                <div className='scheduleBottom w-100 h-25 mt-5'>
                  <div className='footerBtn d-flex justify-content-center align-items-center'>
                    <input
                      type="submit"
                      className="lg_btn primary sheduleFinalizeBtn"
                      value="Finalize"
                      id="finalize"
                      data-dismiss="modal"
                      onClick={(e) => submitABTestSchedule(e)}
                    />
                    <a to="" class="lg_btn tertiary ml-2" data-dismiss="modal">
                      Cancel
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
